import React from 'react'
import StatistikComponent from "./StatistikComponent";
import DHDialog from "../../../general/DHDialog";


export default function StatistikDialog({name, statistik, showPlayerGesamtStatistik, onClose}) {

    return <DHDialog onClose={() => onClose()} title="Statistik" show={true}
                     buttons={[]}
                     showCloseButton={true}
                     comp={<>
                         <StatistikComponent name={name} showPlayerGesamtStatistik={showPlayerGesamtStatistik} statistik={statistik}/>
                     </>}
    />
}
